import { combineReducers } from 'redux';
import map from 'ramda/src/map';
import omit from 'lodash/omit';
import * as types from './constants';
import {
  CANCEL_APPOINTMENT,
  APPOINTMENT_STATUS,
} from '../appointments/constants';
import byId from './reducers/byId';
import chairRentals from './chairRental/reducer';
import brandBarber from './reducers/brandBarber';

function listReducer(state = [], action) {
  switch (action.type) {
    case types.GET_BARBERS:
      return action.response.result;
    case types.ADD_BARBER:
      return [...state, action.response.result];
    case types.DELETE_BARBER:
      return state.filter(id => id !== action.barberId);
    case types.UPDATE_BARBER_ORDER:
      return map(barber => barber.id)(action.barbers);
    default:
      return state;
  }
}

function deletedListReducer(state = [], action) {
  switch (action.type) {
    case types.GET_DELETED_BARBERS:
      if (action.ownerType === 'brand') {
        return action.payload
          .map(barber => ({
            ...barber,
            shops: barber.shops.filter(barberShop => !!barberShop.deletedAt),
          }))
          .filter(barber => !!barber.shops.length);
      }

      return action.payload.filter(barber => !!barber.deletedAt);
    case types.RESTORE_SINGLE_BARBER:
      return state.filter(barber => barber.id !== action.payload.id);
    default:
      return state;
  }
}

function barberAppointments(state = [], action) {
  switch (action.type) {
    case types.IMPORT_SINGLE_BARBER_APPOINTMENTS:
      return action.appointments;
    case CANCEL_APPOINTMENT:
      if (state.length) {
        return state.map((appointment) => {
          if (appointment.id === action.appointmentId) {
            appointment.status = APPOINTMENT_STATUS.canceled;
          }
          return appointment;
        });
      }
      return state;
    default:
      return state;
  }
}

const initialAvailableTimes = { loading: false, items: [] };
function availableTimes(state = initialAvailableTimes, { type, payload }) {
  switch (type) {
    case types.RESET_AVAILABLE_TIMES:
      return { ...initialAvailableTimes };

    case types.REQUEST_AVAILABLE_TIMES:
      return { ...state, loading: true };

    case types.RECEIVE_AVAILABLE_TIMES:
      return { loading: false, items: payload };

    default:
      return state;
  }
}

const nextAvailableTime = (state = { barbers: {}, isFetching: {} }, { type, payload }) => {
  switch (type) {
    case types.FETCH_NEXT_AVAILABLE_TIMES:
      return {
        ...state,
        isFetching: {
          ...state.isFetching,
          [payload]: true,
        },
      };

    case types.FETCH_NEXT_AVAILABLE_TIMES_SUCCESS:
      return {
        ...state,
        barbers: {
          ...state.barbers,
          [payload.id]: payload,
        },
        isFetching: {
          ...omit(state.isFetching, payload.id),
        },
      };

    case types.FETCH_NEXT_AVAILABLE_TIMES_ERROR:
      return {
        ...state,
        isFetching: {
          ...omit(state.isFetching, payload),
        },
      };

    default:
      return state;
  }
};

const permissionPasscodeLoadingState = (state = { isLoading: false }, { type }) => {
  switch (type) {
    case types.BARBER_SET_PERMISSION_CODE_LOADING:
      return { ...state, isLoading: true };
    case types.BARBER_SET_PERMISSION_CODE_LOADED:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};

const barberDaysOffByShopInitialState = {
  isLoading: false,
  daysOffByShop: [],
};

const barberDaysOffByShop = (state = barberDaysOffByShopInitialState, { type, payload }) => {
  switch (type) {
    case types.BARBER_GET_DAYS_OFF_BY_SHOP:
      return {
        ...state,
        isLoading: true,
      };

    case types.BARBER_SET_DAYS_OFF_BY_SHOP:
      return {
        ...state,
        daysOffByShop: payload,
        isLoading: false,
      };

    case types.BARBER_GET_DAYS_OFF_BY_SHOP_ERROR:
    case types.RESET_SINGLE_BRAND_BARBER:
      return {
        ...barberDaysOffByShopInitialState,
      };

    default:
      return state;
  }
};

const barberDaysOnByShopInitialState = {
  isLoading: false,
  daysOnByShop: [],
};

const barberDaysOnByShop = (state = barberDaysOnByShopInitialState, { type, payload }) => {
  switch (type) {
    case types.BARBER_GET_DAYS_ON_BY_SHOP:
      return {
        ...state,
        isLoading: true,
      };

    case types.BARBER_SET_DAYS_ON_BY_SHOP:
      return {
        ...state,
        daysOnByShop: payload,
        isLoading: false,
      };

    case types.BARBER_GET_DAYS_ON_BY_SHOP_ERROR:
    case types.RESET_SINGLE_BRAND_BARBER:
      return {
        ...barberDaysOnByShopInitialState,
      };

    default:
      return state;
  }
};

const barberSchedulesInitialState = {
  isLoading: false,
  schedules: [],
};

const barberSchedules = (state = barberSchedulesInitialState, { type, payload }) => {
  switch (type) {
    case types.BARBER_GET_SCHEDULES:
      return {
        ...state,
        isLoading: true,
      };

    case types.BARBER_SET_SCHEDULES:
      return {
        ...state,
        schedules: payload,
        isLoading: false,
      };

    case types.BARBER_GET_SCHEDULES_ERROR:
    case types.RESET_SINGLE_BRAND_BARBER:
      return {
        ...barberSchedulesInitialState,
      };

    default:
      return state;
  }
};

export default combineReducers({
  byId,
  list: listReducer,
  deleted: deletedListReducer,
  barber_appointments: barberAppointments,
  chairRentals,
  availableTimes,
  nextAvailableTime,
  permissionPasscodeLoadingState,
  barberDaysOffByShop,
  barberDaysOnByShop,
  barberSchedules,
  brandBarber,
});
